import React, { useState, useEffect, useRef } from 'react';
import SelectItem from './SelectItem';
import useDetectMobile from './useDetectMobile';

export default function SelectDropdown({ listItems, setStateHandler }) {
  const [isOpen, setOpen] = useState(false);
  const selectRef = useRef(null);
  const [isMobile] = useDetectMobile();

  const handleClick = () => {
    if (!isOpen && selectRef && selectRef.current && isMobile) {
      selectRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    setOpen(!isOpen);
  };

  useEffect(() => {
    const selectDropdown = selectRef.current;

    const handleMouseLeave = () => {
      setOpen(false);
    };

    selectDropdown.addEventListener('mouseleave', handleMouseLeave);
  }, [selectRef]);

  const showSelectedCount = () => {
    if (listItems.length === 0) return;
    let selects = 0;

    listItems.forEach((item) => (item.selected === true ? selects++ : null));

    return selects === 0 ? 'select' : `${selects} selected`;
  };

  return (
    <div ref={selectRef} className="select-dropdown">
      <div onClick={() => handleClick()} className="select-dropdown__header">
        <div className="select-dropdown__header-label">
          <div>{showSelectedCount()}</div>
        </div>
        <i className="icon-caret-dropdown"></i>
      </div>
      {isOpen && (
        <div className={`select-dropdown__list open `}>
          {listItems.map((item, index) => (
            <SelectItem
              key={index}
              item={item}
              setStateHandler={setStateHandler}
            />
          ))}
        </div>
      )}
    </div>
  );
}
